export const MyProfileJobRoleDetailsReducer = (state = {}, action) => {
    if (action.type === 'GET_UPG_MY_PROFILE_JOB_ROLE_DETAILS') {
      return {
        ...state,
        MyProfileJobRoleDetailsRd: action.payload,
      };
    } else {
      return state;
    }
  };